import { modeFromPath, navFor } from "./nav";

export interface BackTarget {
  href: string;
  label: string;
}

/** Pages whose parent is not a nav item. Most specific first. */
const OVERRIDES: [RegExp, (m: RegExpMatchArray) => BackTarget][] = [
  [
    /^(\/t\/[^/]+\/periods\/[^/]+)\/amend$/,
    (m) => ({ href: m[1] ?? "/", label: "Back to the period" }),
  ],
  [/^\/supervise\/(periods|sign)\//, () => ({ href: "/supervise", label: "Back to queue" })],
];

/**
 * The one Back button. Every page except a home page gets a target: an override, else the
 * nearest ancestor that is a nav item, else home. It can never come back empty for a
 * non-home path, and back.test.ts walks every route in the router to prove it.
 */
export function backTarget(pathname: string, homeHref: string): BackTarget | null {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path === homeHref) return null;
  for (const [pattern, build] of OVERRIDES) {
    const match = path.match(pattern);
    if (match) return build(match);
  }
  const trackId = /^\/t\/([^/]+)/.exec(path)?.[1];
  const items = navFor(modeFromPath(path), trackId).filter((item) => item.to !== homeHref);
  const parts = path.split("/");
  for (let end = parts.length - 1; end > 1; end--) {
    const ancestor = parts.slice(0, end).join("/");
    const item = items.find((candidate) => candidate.to === ancestor);
    if (item) return { href: item.to, label: `Back to ${item.label.toLowerCase()}` };
  }
  return { href: homeHref, label: "Back to Home" };
}
